// vue.config.js
const path = require("path")
// eslint-disable-next-line
// const express = require('express')

module.exports = {
    outputDir: process.env.NODE_ENV === 'production'
        ? path.resolve(__dirname, "./dist")
        : (process.env.NODE_ENV === 'test'
            ? path.resolve(__dirname, "./dist-test")
            : path.resolve(__dirname, "./dist-dev")
        ),
    publicPath: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development'
        ? '/'
        : '/ponderosa-software/dist-test/',
    pages: {
        index: {
            // entry for the page
            // entry: 'src/index/main.js',
            entry: 'src/main.js',
            // the source template
            template: 'public/index.html',
            // output as dist/index.html
            filename: 'index.html',
            // when using title option,
            // template title tag needs to be <title><%= htmlWebpackPlugin.options.title %></title>
            title: 'Index Page',
            // chunks to include on this page, by default includes
            // extracted common chunks and vendor chunks.
            chunks: ['chunk-vendors', 'chunk-common', 'index']
        },
        // when using the entry-only string format,
        // template is inferred to be `public/subpage.html`
        // and falls back to `public/index.html` if not found.
        // Output filename is inferred to be `subpage.html`.
        // subpage: 'src/subpage/main.js'
    },
    devServer: {
        overlay: {
            warnings: true,
            errors: true
        },
        // proxy: 'http://localhost:8081',
        /*
        proxy: {
            '^/api': {
                target: '<url>',
                ws: true,
                changeOrigin: true
            },
            '^/foo': {
                target: '<other_url>'
            }
        }
        */
    },
    lintOnSave: process.env.NODE_ENV !== 'production',
    css: {
        loaderOptions: {
            css: {
                // options here will be passed to css-loader
            },
            postcss: {
                // options here will be passed to postcss-loader
            }
        }
    },
    pluginOptions: {
        foo: {
            // plugins can access these options as
            // `options.pluginOptions.foo`.
        }
    }
}
